(() => {
  'use strict';
  const dialog = document.querySelector('[data-welcome-dialog]');
  const triggers = () => document.querySelectorAll('[data-welcome-open]');
  if (!dialog) {
    triggers().forEach((trigger) => { trigger.hidden = true; });
    return;
  }
  if (typeof dialog.showModal !== 'function') {
    dialog.setAttribute('open', '');
    dialog.style.position = 'static';
    triggers().forEach((trigger) => { trigger.hidden = true; });
    dialog.querySelectorAll('[data-welcome-close]').forEach((button) => { button.hidden = true; });
    return;
  }

  const storageKey = 'hc-welcome-dismissed-until';
  const sevenDays = 7 * 24 * 60 * 60 * 1000;
  const desktop = window.matchMedia('(hover: hover) and (pointer: fine)');
  const form = dialog.querySelector('form');
  let opener;
  let shownThisPage = false;
  let engagedAt = null;
  let pendingResult = location.hash === '#HcWelcomeForm' && Boolean(dialog.querySelector('[data-welcome-result]'));

  const preferencesAllowed = () => {
    try { return window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() === true; }
    catch { return false; }
  };
  const dismissed = () => {
    if (!preferencesAllowed()) return true;
    try { return Number(window.localStorage.getItem(storageKey) || 0) > Date.now(); }
    catch { return true; }
  };
  const rememberDismissal = () => {
    if (!preferencesAllowed()) return;
    try { window.localStorage.setItem(storageKey, String(Date.now() + sevenDays)); }
    catch { /* Storage unavailable: no alternate cookie or tracking fallback. */ }
  };
  const visible = (element) => Boolean(element.getClientRects().length) && getComputedStyle(element).visibility !== 'hidden';
  const blocked = () => {
    if (document.visibilityState !== 'visible') return true;
    if ([...document.querySelectorAll('dialog[open], [aria-modal="true"], [data-header-dropdown][open]')].some((element) => element !== dialog && visible(element))) return true;
    return [...document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs, .shopify-pc__banner__dialog, .shopify-pc__prefs__dialog, [data-cookie-banner], [data-consent-dialog]')].some(visible);
  };
  const shoppingBusy = () => {
    if (/\/(?:cart|checkout|checkouts|account|challenge)(?:\/|$)/i.test(location.pathname)) return true;
    return document.activeElement?.matches('input, textarea, select, [contenteditable="true"], [contenteditable=""]');
  };
  const observeBlockers = new MutationObserver(() => {
    if (dialog.open && blocked()) dialog.close();
  });
  const show = (trigger, automatic = false, restoreFocusTo = null) => {
    if (dialog.open || blocked() || shoppingBusy()) return false;
    if (automatic && (shownThisPage || dismissed())) return false;
    opener = restoreFocusTo || trigger || document.activeElement;
    dialog.showModal();
    shownThisPage = true;
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    observeBlockers.observe(document.body, { attributes: true, attributeFilter: ['open', 'hidden', 'style', 'class', 'aria-hidden'], childList: true, subtree: true });
    return true;
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-welcome-open]');
    if (trigger) {
      event.preventDefault();
      const menu = trigger.closest('[data-menu-dialog]');
      if (menu?.open) {
        const menuOpener = document.querySelector('[data-menu-open][aria-expanded="true"]') || document.querySelector('[data-menu-open]');
        menu.addEventListener('close', () => {
          requestAnimationFrame(() => show(trigger, false, menuOpener));
        }, { once: true });
        menu.close();
      } else {
        show(trigger);
      }
    }
    if (event.target.closest('[data-welcome-close]') && dialog.open) dialog.close();
  });
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;
    const focusable = [...dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]')].filter((element) => element.tabIndex >= 0 && visible(element));
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (!first) return;
    const current = document.activeElement;
    if (event.shiftKey && (current === first || !focusable.includes(current))) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && (current === last || !focusable.includes(current))) {
      event.preventDefault(); first.focus();
    }
  });
  dialog.addEventListener('close', () => {
    observeBlockers.disconnect();
    rememberDismissal();
    triggers().forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    if (!blocked() && opener?.isConnected) opener.focus({ preventScroll: true });
  });

  // Let Shopify handle validation, bot protection, submission, and the server result.
  form?.addEventListener('submit', () => { shownThisPage = true; });
  const showResult = () => {
    if (!pendingResult || shoppingBusy()) return;
    if (show()) {
      pendingResult = false;
      dialog.querySelector('[data-welcome-result]')?.focus({ preventScroll: true });
    }
  };
  const engage = () => {
    if (document.visibilityState === 'visible' && engagedAt === null) engagedAt = performance.now();
  };
  document.addEventListener('pointerdown', engage, { passive: true });
  document.addEventListener('keydown', engage, { passive: true });
  document.addEventListener('scroll', engage, { passive: true });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState !== 'visible') engagedAt = null; });
  document.addEventListener('mouseout', (event) => {
    if (!desktop.matches || event.relatedTarget !== null || event.clientY > 0 || event.buttons !== 0) return;
    if (engagedAt !== null && performance.now() - engagedAt >= 30000) show(null, true);
  });
  document.addEventListener('visitorConsentCollected', showResult);
  window.addEventListener('load', showResult, { once: true });
  showResult();
  // Mobile has no reliable exit signal: the manual footer trigger remains available.
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
})();
